module.exports = __webpack_public_path__ + "static/images/idCard-1.f95eb0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/idCard-1.png
// module id = PGi+
// module chunks = 0